import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../shareModule/services/common.service';

@Component({
  selector: 'app-admin-sheet',
  templateUrl: './admin-sheet.component.html',
  styleUrl: './admin-sheet.component.scss',
})
export class AdminSheetComponent implements OnInit {
  public sheets = [];
  public selectedSheet = null;
  public selectedTab = null;
  public subCategories = [];
  public newSheet = {
    name: '',
    opt: null,
    linkedResourceId: null,
    ownerType: 'CATEGORY'
  };
  public newSheetTab = {
    name: '',
  };

  //public hiddenCols = new Set()
  public isLocked = false;
  public lockedCols =  new Set([
    // 0,  // GROUP_ID_COL
    // 6,  // VARIABLE_PARENT_COL
    // 7,  // VARIABLE_ID_COL
    // 10, // SUB_VARIABLE_PARENT_COL
    // 11, // SUB_VARIABLE_ID_COL
  ]);
  public subVars = new Map()

  public typeOfSelectedCategory = []
  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {

    this.fetchSheets();
    this.subCategories = structuredClone(this.commonService.subCategoryList);
    this.fetchAllTypes()
    this.fetchAllSubVars()
  }
  private fetchAllTypes(){
    this.auth.fetchAllTypes().subscribe({
      next: (data: any)=>{
        this.typeOfSelectedCategory = data.body;

      },
      error:(error) => this.toastr.error(error.error.message),
     })
  }

  public fetchAllSubVars(){
    this.subVars.clear()
    this.auth.fetchAllSubVars().subscribe({
      next: data =>{
         for(const subVar of data.body){
          this.subVars.set(subVar.id + "", subVar)
         }
      }
    })

  }
  public selectTypeForEstimator(type){
    this.newSheet.name = type.name;
    this.newSheet.linkedResourceId = `TYPE-${type.id}`
    this.newSheet.ownerType = 'TYPE'

  }
  public selectSubcatForEstimator(subcat){
     this.newSheet.linkedResourceId =  `CATEGORY-${subcat.categorieChildId}`; 
     this.newSheet.name = subcat.categoryName; 
     this.newSheet.ownerType = 'CATEGORY'
 

    
  }
  private getSubVarId(row, col){
    if(!this.selectedTab || col % 2 == 0){
      return null
    }
    const {content} = this.selectedTab;
    return content?.[row-1]?.[col-1]?.split('SUB VARIABLE ID')?.[1]?.trim()

  }
  public getSubVarLinkedValue(row, col){
    const subVar = this.subVars.get(this.getSubVarId(row, col) + "")
    //console.log({subVar}, this.getSubVarId(row, col), this.subVars)
    return subVar?.connectedSubVar
  }
  public getSubVarExp(row, col){
    const subVar = this.subVars.get(this.getSubVarId(row, col) + "")
    //console.log({subVar}, this.subVars.keys())
    return subVar?.connectionExpression
  }
  public async deleteSheet(sheet){
    const res = await this.local.confirmYesNo({
      title: 'Are you sure you want to delete this sheet',
      icon: 'warning',
      text: '',
    });
    if (!res.isConfirmed) {
      return;
    }
    this.auth.deleteAdminSheet(sheet.id).subscribe({
      next:()=> { this.toastr.success("Removed"); this.selectedSheet = null; this.fetchSheets() },
      error: (error) => this.toastr.error(error.error.message),
    })
  }

  refreshCurrentSheet() {
    if (this.selectedSheet) {
      this.fetchAllSubVars()
      this.selectedSheet = this.sheets.find(
        (sheet) => sheet.id == this.selectedSheet.id,
      );
      console.log('selected sheet is ', this.selectedSheet);
      if (this.selectedSheet?.adminSheetTabs?.length) {
        console.log('tabs are present');
        if (!this.selectedTab) {
          console.log('Refreshing selected tab');
          this.selectedTab = this.selectedSheet.adminSheetTabs[0];
        } else {
          console.log(this.selectedSheet?.adminSheetTabs, this.selectedTab)
          this.selectedTab = this.selectedSheet?.adminSheetTabs.find(
            (tab) => tab.name == this.selectedTab.name,
          );
        }
      }
    }
  }


  showCol(row, col){ //trimming rows
    return col % 2 || col == 0
     return true
  }

  fetchSheets() {
    this.isLocked = true;
    this.auth.getAllAdminSheets().subscribe({
      next: (data) => {
        this.isLocked = false;
        this.sheets = data.body;
        this.refreshCurrentSheet();
      },
      error: (error) => { this.isLocked = false;this.toastr.error(error.error.message)},
    });
  }
  isDropValue(col, rowValues){
    return rowValues && col > 0 && rowValues[col - 1] == "SUB VARIABLE VALUE"
  }
  linkOptionChanged(event, row, col){
    console.log('drop down change event', event.target.value)

    if(!this.selectedTab || col == 0){
      return
    }
    const {content} = this.selectedTab;

    const connectedToId = event.target.value == 'LVAR' ? null : event.target.value  ;
    const subVarId = content[row-1][col-1].split('SUB VARIABLE ID')[1];

    this.auth.linkSubVar(subVarId, connectedToId).subscribe({
      next: ()=>{
        this.toastr.success("DONE");
        this.fetchSheets()
      },
      error: error =>{
        this.toastr.error(error.error.message)
        this.fetchSheets()
      }
    })
  }
  getLinkOptions(row, col){
    if(!this.selectedTab || col == 0){
      return []
    }
    const {content} = this.selectedTab;

    const returnValue = []
    
    let ownerVariableIndex = row;
    let foundVariable = false
    for(; ownerVariableIndex > 0; ownerVariableIndex --){
       if(content[ownerVariableIndex][col-1].startsWith('VARIABLE')){ //since 1 sow named 
         foundVariable = true;
         break
       }   
    }
    if(!foundVariable){
      console.log("didn't found variable")
      return returnValue;
    }
    
   for(let i=ownerVariableIndex+1;  i < content.length;i++){
      const cellValue = content[i][col-1];
      if(cellValue.startsWith('VARIABLE')){
        break
      }
      else if(cellValue.startsWith('SUB VARIABLE ID')){
    
        returnValue.push({name: content[i]?.[col],  id: cellValue.split('SUB VARIABLE ID')?.[1]?.trim()})
      }
   }


    return returnValue;
  }
  createNewSheet() {
    this.auth
      .createAdminSheet(
        this.newSheet.name,
        this.newSheet.opt,
        this.newSheet.linkedResourceId,
        {
          ownerType: this.newSheet.ownerType
        }

      )
      .subscribe({
        next: () => {
          this.toastr.success('New Sheet Created');
          this.newSheet.name = '';
          this.newSheet.linkedResourceId = null;
          this.newSheet.opt = '';
          this.typeOfSelectedCategory = []
          this.fetchSheets();
        },
        error: (error) => this.toastr.error(error.error.message),
      });
  }
  async deleteSheetTab(sheetTabId) {
    const res = await this.local.confirmYesNo({
      title: 'Are you sure you want to delete this tab',
      icon: 'warning',
      text: '',
    });
    if (!res.isConfirmed) {
      return;
    }
    this.auth.deleteAdminSheetTab(sheetTabId).subscribe({
      next: () => {
        this.toastr.success('Sheet tab removed!');
         this.selectedTab = null;
        this.fetchSheets();
        //this.selectedSheet = null;
       
        
      },
      error: (error) => this.toastr.error(error.error.message),
    });
  }
  changeValue(event, row, col) {
    this.isLocked = true;
    this.cdr.detectChanges()
    this.auth
      .changeSheetTabContent(this.selectedTab.id, row, col, event.target.value)
      .subscribe({
        next: (data) => {
          this.isLocked = false;
          this.toastr.success(data.message);
          this.fetchSheets();
          this.fetchAllTypes()
          this.cdr.detectChanges()
        },
        error: (error) => {
          this.isLocked = false;
          this.fetchSheets()
           this.cdr.detectChanges()
          this.toastr.error(
            'Something went wrong when changing value: ' + error.error.message,
          );
        },
      });
  }
  createNewSheetTab() {
    this.auth
      .createAdminSheetTab(this.selectedSheet?.id, this.newSheetTab.name)
      .subscribe({
        next: () => {
          this.toastr.success('Tab Created');
          this.fetchSheets();
        },
        error: (error) => this.toastr.error(error.error.message),
      });
  }
}
